import * as React from 'react';
import System from 'src/helper/system';

const EmailSentPopup = (props) => {
    const { translation: t } = System;
    const { SetStatus, data } = props;

    return (
        <>
            <div className="avnet-modal modal-350">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    {!data?.isRegister && (
                        <button type="button" className="close" data-dismiss="modal" onClick={() => { SetStatus(false) }}>×</button>
                    )}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                            {typeof (data.result) !== 'object' && data.result.includes("success") ? t('emailSent') : t('emailFailed')}
                        </h1>
                    </div>
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            {typeof (data.result) !== 'object' && data.result.includes("success") ? t('emailSentSuccessfully') : t('emailHasNotSent')}

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary minw140" onClick={() => {SetStatus(false)}}>
                                {t('close')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmailSentPopup;